import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const workbenchGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasAideRole()) {
    return true;
  }

  return router.createUrlTree(['/sign-in'], { queryParams: { error: 'unauthorized' } });
};
